import { t, Trans } from '@lingui/macro';

import Panel from '../../page-framework/panel/PanelDecorator';
import {
    PANEL_CATEGORIES,
    PANEL_PRIORITIES,
    STATUS_BREAKOUT_CHART_PANEL_PREVIEW_IMAGE,
} from '../../page-framework/panel/PanelRegistry';
import { panelPropTypes, panelPropDefaults } from '../../page-framework/panel/PanelPropTypes';
import usePanelDataService from '../../../services/PanelDataService';
import StatusBreakoutRow from '../../status-breakout/StatusBreakoutRow';
import FixedLabelContainer from '../../fixed-label-container/FixedLabelContainer';
import { siteFilterId, timeRangeFilterId } from '../../filters';
import MessageOverlay from '../../charts/message-overlay/MessageOverlay';

const title = t`Site Access Points Status`;

const countsSource = {
    url: '/query/table',
    params: {
        type: 'site',
        metrics: ['status', 'apCounts'],
        renderAsEntity: 'true',
        trends: ['status', 'apCounts'],
    },
};

function SiteAccessPointsPanel() {
    const counts = usePanelDataService(countsSource);
    const statusData = counts?.data?.[0];

    if (!statusData) {
        return <MessageOverlay message={<Trans>No data available</Trans>} />;
    }

    return (
        <FixedLabelContainer>
            <StatusBreakoutRow
                noSelection
                page="/access-points"
                title={<Trans>Access Points</Trans>}
                metric="apCounts"
                data={statusData}
            />
        </FixedLabelContainer>
    );
}

SiteAccessPointsPanel.propTypes = panelPropTypes;

SiteAccessPointsPanel.defaultProps = {
    ...panelPropDefaults,
    title,
    contentHeight: 60,
    minContentHeight: 60,
    disableVerticalResize: true,
};

export default Panel({
    typeAlias: 'SiteAccessPointStatusBreakout',
    catalogEntry: {
        category: PANEL_CATEGORIES.SITE,
        priority: PANEL_PRIORITIES.SUBLIST,
        title,
        description: t`Status counts breakdown for wireless access points (APs) for a selected site`,
        previewImage: STATUS_BREAKOUT_CHART_PANEL_PREVIEW_IMAGE,
        ipm: true,
    },
    filters: {
        required: [timeRangeFilterId, siteFilterId],
        optional: [],
    },
})(SiteAccessPointsPanel);
